import { useSafeContext } from '@aspendental/shared-utils/react';
import { createContext, useMemo } from 'react';
import baseConfig from '@shared-components/theme/BaseBrandThemeConfig';
import { TAGBrand, BrandThemeConfig } from '@shared-components/types';
import { httpClient } from '@utils/httpClient';
export interface IAppContext {
  theme: TAGBrand;
  environment: EnvironmentType;
  config: BrandThemeConfig;
  appName: string;
  appVersion: string;
  stateCodeFromHeaders?: string;
}
export interface IAppContextProvider extends IAppContext {
  children: React.ReactNode;
}
const AppContext = createContext<IAppContext>({
  theme: TAGBrand.Lovet,
  environment: 'prod',
  config: baseConfig,
  appName: 'tag_unknown',
  appVersion: 'unknown',
  stateCodeFromHeaders: ''
});
AppContext.displayName = 'AppContext';
type EnvironmentType = 'local' | 'dev' | 'stage' | 'prod';
export function AppContextProvider({
  theme,
  environment,
  config,
  appName,
  appVersion,
  children,
  stateCodeFromHeaders
}: Readonly<IAppContextProvider>) {
  const appContext = useMemo(() => ({
    theme,
    environment,
    config,
    appName,
    appVersion,
    stateCodeFromHeaders: stateCodeFromHeaders ?? ''
  }), [theme, environment, config, appName, appVersion, stateCodeFromHeaders]);
  const revspringApiUrl = environment === 'prod' ? config.services.prod.REVSPRING_API_URL : config.services.nonprod.REVSPRING_API_URL;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
  httpClient.getHTTPClient().defaults.baseURL = revspringApiUrl;
  return <AppContext.Provider value={appContext} data-sentry-element="AppContext.Provider" data-sentry-component="AppContextProvider" data-sentry-source-file="AppContextProvider.ctx.tsx">{children}</AppContext.Provider>;
}
export function useAppContext() {
  return useSafeContext(AppContext);
}